// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_UPLOAD_UNABLE_TO_LOAD_PHOTO = "Fotografia sa ned\u00e1 na\u010d\u00edta\u0165. Sk\u00faste in\u00fd s\u00fabor";
export const PHOTO_UPLOAD_UNABLE_TO_LOAD_PHOTO_TRY_ANOTHER_OR_DIFFERENT_SOURCE = "Fotku sa nepodarilo na\u010d\u00edta\u0165. Sk\u00fas vybra\u0165 in\u00fa alebo pou\u017ei in\u00fd zdroj.";
export const PHOTO_UPLOAD_UNABLE_TO_SCALE_PHOTO = "Fotografiu sa nepodarilo spracova\u0165. Sk\u00faste in\u00fd s\u00fabor";
